import React, { useState, useEffect, useContext, useLayoutEffect } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";

import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import FormControlLabel from "@mui/material/FormControlLabel";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import {
    CustomTextField,
    CustomTitle,
    CustomText,
    CustomButton,
    CustomButton1,
    CustomCheckbox,
} from "../../components/Custom";

import Service from "../../services";
import { useFormik } from "formik";

import validationSchema from "./validation";
import { AppContext } from "../../context";
import { Divider, FormControl, Typography } from "@mui/material";
import { Checkbox, Select, InputLabel } from '@mui/material';
import MenuItem from "@mui/material/MenuItem";
import CustomSelectWithTags from '../../components/Validation'
// import toast from 'react-toastify';
// import Service from "../../services";



const API_URL = process.env.REACT_APP_API_URL;
const EditRequestPage = (props) => {
    const appdata = useContext(AppContext);
    const [requestTypes, setRequestTypes] = appdata[4];
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);
    const [errorMsg, setErrorMsg] = useState(false);
    const [update, setUpdate] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);
    const [selectedValidations, setSelectedValidations] = useState([]);
    const [validationOptions, setValidationOptions] = useState([]);
    const handleValidationChange = (event) => {
        setSelectedValidations(event.target.value);
    };
    const [openTemplate, setOpenTemplate] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState();

    const handleClickOpenTemplate = (id) => {
        setSelectedTemplate(id);
        setOpenTemplate(true);
    };

    

    const handleCloseTemplate = () => {
        setUpdate(true);
        setSelectedValidations([]);
        setErrorMessages([]);
        setErrorMsg(false);
        setSubmitted(false);
        setOpenTemplate(false);
    };



    //FETCH ALL REQUEST TYPES
    async function fetchRequestTypes() {
        const response = await Service.getRequestTypes();

        if (response.status === 200) {
            console.log(response);
            setRequestTypes(response.data.data);
        }
    }
    useEffect(() => {
        setUpdate(false);
        fetchRequestTypes();
    }, [update]);
    console.log(requestTypes);

    const navigate = useNavigate();

    const getInitialValues = (selectedTemplate) => {
        const selectedRequestType = requestTypes.find(item => item.request_id === selectedTemplate);
        if (!selectedRequestType) {
          return { // default values if no template is selected
            requestName: "",
            database_type: "",
            dbOperationType: "",
            database_name: "",
            database_table: "",
            noOfColumnsRequired: 0,
            executionMethod: "",
            zonalApproval: false,
            shpHeadApproval: false,
            overrideApprovals: false,
            validations: [],
          };
        }
        return {
            requestName: selectedRequestType.request_name || "",
            database_type: selectedRequestType.db_type || "",
            dbOperationType: selectedRequestType.db_operation_type || "",
            database_name: selectedRequestType.database_name || "",
            database_table: selectedRequestType.database_table || "",
            noOfColumnsRequired: selectedRequestType.no_of_columns_required || 0,
            executionMethod: selectedRequestType.execution_method || "",
            zonalApproval: selectedRequestType.zonal_approval || false,
            shpHeadApproval: selectedRequestType.shp_head_approval || false,
            overrideApprovals: selectedRequestType.execution_method === "override",
            validations: selectedRequestType.validations || [],
          };
        };

    

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: getInitialValues(selectedTemplate),
        validationSchema: validationSchema,
        onSubmit: (values, { resetForm }) => {
            saveFormData(selectedTemplate, resetForm);
        },
    });


    useEffect(() => {
        setSelectedValidations(formik.values.validations);
      }, [formik.values.validations]);

    useEffect(() => {
        formik.setValues(getInitialValues(selectedTemplate));
      }, [selectedTemplate, requestTypes]); // Also consider requestTypes changes

    //HANDLE FORM SUBMIT
    async function saveFormData(requestId, resetForm) {
        let payload = {
            request_id: requestId,
            validations: selectedValidations,
        };
        console.log(typeof (requestId), "here")

        setErrorMsg(false);
        setSubmitted(false);
        setLoading(true);

        try {
            // console.log(payload);
            const response = await Service.updateTemplateValidation(payload);
            console.log(response, payload, "payload")



            if (response.status === 200 || response.status === 201) {
                setLoading(false);
                setSubmitted(true);
                setUpdate(true);
                resetForm();
            }
            else {
                let errorMessages = response?.message;
                console.log(errorMessages, "error messagess")

                // Ensure errorMessages is always treated as an array
                if (!Array.isArray(errorMessages)) {
                    errorMessages = [errorMessages];
                }

                setErrorMessages(errorMessages);
                setLoading(false);
                setErrorMsg(true);
            }
        } catch (error) {
            setLoading(false);
            console.log(error, "error messages")
        }
    }

    useEffect(() => {
        async function fetchValidationTypes() {
            try {
                const response = await Service.getValidationTypes();
                setValidationOptions(response?.data?.data)
                console.log("response", response?.data?.data)
            } catch (error) {
                console.error("Failed to fetch validation types", error);
            }
        }

        fetchValidationTypes();
    }, [])



    const handleClose = () => {
        setShowErrorModal(false);
    };

    const removeValidation = (id) => {
        setSelectedValidations((prev) => prev.filter((item) => item !== id));
      };

    return (
        <div className="container">
            <Box container>
                <Box>
                    {/* <div>{displayForecastGroup}</div> */}
                    <CustomTitle sx={{ fontSize: "20px", mb: 2 }}>
                        Edit Request Template
                    </CustomTitle>

                    <Box
                        sx={{
                            border: "1px solid",
                            borderRadius: "10px",
                            p: 2,
                        }}
                    >
                        <List
                            sx={{
                                width: "100%",
                            }}
                            aria-label="contacts"
                        >
                            {requestTypes.map((item, index) => (
                                <>
                                    <ListItem key={index} fullWidth sx={{ py: 0 }}>
                                        <ListItemButton
                                            onClick={() => handleClickOpenTemplate(item.request_id)}
                                        >
                                            <Card
                                                sx={{ width: "100%", boxShadow: "-3px 2px #d3d3d3" }}
                                            >
                                                <CardContent>
                                                    <Box>
                                                        <Typography
                                                            sx={{ fontWeight: "600" }}
                                                        >{`${item.request_name}`}</Typography>
                                                        <Typography
                                                            sx={{ fontSize: "13px" }}
                                                        >{`${item.description}`}</Typography>
                                                    </Box>
                                                </CardContent>
                                            </Card>
                                        </ListItemButton>
                                    </ListItem>
                                </>
                            ))}
                            <Divider sx={{ mt: 3 }} />
                            <CustomText sx={{ fontSize: "12px", textAlign: "center" }}>
                                You have {requestTypes.length} templates
                            </CustomText>
                        </List>
                        {requestTypes.length > 0 &&
                            requestTypes.map((item, index) =>
                                item.request_id === selectedTemplate ? (
                                    <>
                                        <Dialog
                                            key={selectedTemplate}
                                            open={openTemplate}
                                            onClose={handleCloseTemplate}
                                            fullWidth
                                            maxWidth="md"
                                        >
                                            <DialogTitle> {item.request_name}</DialogTitle>
                                            <DialogContent>
                                                {submitted && !errorMessages.length ? (
                                                    <Box
                                                        sx={{
                                                            textAlign: "center",
                                                            justifyContent: "center",
                                                            border: 1,
                                                            borderRadius: 1,
                                                            p: 3,
                                                            mb: 2,
                                                        }}
                                                    >
                                                        <h3 style={{ color: "green" }}>
                                                            Request Logged Successfully
                                                        </h3>
                                                    </Box>
                                                ) : errorMessages.length > 0 ? (
                                                    <Box
                                                        sx={{
                                                            textAlign: "center",
                                                            justifyContent: "center",
                                                            border: 1,
                                                            borderRadius: 1,
                                                            p: 3,
                                                            mb: 2,
                                                            overflowY: 'auto',
                                                            maxHeight: '400px',  // Optional: Adjust height as needed
                                                        }}
                                                    >
                                                        <Typography variant="h6" component="h2" color="red">
                                                            Failed Requests
                                                        </Typography>
                                                        <List>
                                                            {errorMessages.map((message, index) => (
                                                                <ListItem key={index}>
                                                                    <ListItemText primary={message} />
                                                                </ListItem>
                                                            ))}
                                                        </List>
                                                    </Box>
                                                ) : (
                                                    <Box sx={{ padding: 2, backgroundColor: 'white' }}>
                                                        <form onSubmit={formik.handleSubmit}>
                                                            <CustomText>Request Name</CustomText>
                                                            <CustomTextField
                                                                type="text"
                                                                name="requestName"
                                                                id="requestName"
                                                                disabled
                                                                value={formik.values.requestName}
                                                                onChange={formik.handleChange}
                                                                placeholder="Enter request name"
                                                                error={
                                                                    formik.touched.requestName &&
                                                                    Boolean(formik.errors.requestName)
                                                                }
                                                                helperText={
                                                                    formik.touched.requestName && formik.errors.requestName
                                                                }
                                                                sx={{ mb: 2 }}
                                                                fullWidth
                                                            />
                                                            <br />
                                                            <CustomText>Database Type</CustomText>
                                                            <CustomTextField
                                                                name="database_type"
                                                                id="database_type"
                                                                value={formik.values.database_type}
                                                                onChange={formik.handleChange}
                                                                disabled
                                                                // label="Select Season"
                                                                select
                                                                error={
                                                                    formik.touched.database_type &&
                                                                    Boolean(formik.errors.database_type)
                                                                }
                                                                helperText={
                                                                    formik.touched.database_type && formik.errors.database_type
                                                                }
                                                                fullWidth
                                                                sx={{ mb: 2 }}
                                                            >
                                                                <MenuItem value={1}>MySQL-GCP</MenuItem>
                                                                <MenuItem value={2}>Postgress</MenuItem>
                                                                <MenuItem value={3}>MySQL-Bluehost</MenuItem>
                                                            </CustomTextField>
                                                            <div>
                                                                <CustomSelectWithTags
                                                                    selectedValidations={selectedValidations}
                                                                    validationOptions={validationOptions}
                                                                    handleValidationChange={handleValidationChange}
                                                                    removeValidation={removeValidation}
                                                                />
                                                            </div>
                                                            <CustomText>DB Operation Type</CustomText>
                                                            <CustomTextField
                                                                name="dbOperationType"
                                                                id="dbOperationType"
                                                                value={formik.values.dbOperationType}
                                                                onChange={formik.handleChange}
                                                                disabled
                                                                // label="Select Season"
                                                                error={
                                                                    formik.touched.dbOperationType &&
                                                                    Boolean(formik.errors.dbOperationType)
                                                                }
                                                                helperText={
                                                                    formik.touched.dbOperationType &&
                                                                    formik.errors.dbOperationType
                                                                }
                                                                select
                                                                fullWidth
                                                                sx={{ mb: 2 }}
                                                            >
                                                                <MenuItem value={"insert"}>Insert</MenuItem>
                                                                <MenuItem value={"update"}>Update</MenuItem>
                                                                <MenuItem value={"delete"}>Delete</MenuItem>
                                                            </CustomTextField>

                                                            <br />
                                                            <CustomText>Database name</CustomText>
                                                            <CustomTextField
                                                                type="text"
                                                                name="database_name"
                                                                id="database_name"
                                                                value={formik.values.database_name}
                                                                onChange={formik.handleChange}
                                                                disabled
                                                                placeholder="Enter database name"
                                                                error={
                                                                    formik.touched.database_name &&
                                                                    Boolean(formik.errors.database_name)
                                                                }
                                                                helperText={
                                                                    formik.touched.database_name && formik.errors.database_name
                                                                }
                                                                sx={{ mb: 2 }}
                                                                fullWidth
                                                            />
                                                            <CustomText>Database table</CustomText>
                                                            <CustomTextField
                                                                type="text"
                                                                name="database_table"
                                                                id="database_table"
                                                                value={formik.values.database_table}
                                                                disabled
                                                                onChange={formik.handleChange}
                                                                placeholder="Enter database/table"
                                                                error={
                                                                    formik.touched.database_table &&
                                                                    Boolean(formik.errors.database_table)
                                                                }
                                                                helperText={
                                                                    formik.touched.database_table &&
                                                                    formik.errors.database_table
                                                                }
                                                                sx={{ mb: 2 }}
                                                                fullWidth
                                                            />

                                                            <CustomText>No. of Columns Required</CustomText>
                                                            <CustomTextField
                                                                type="number"
                                                                onWheel={(event) => event.target.blur()}
                                                                name="noOfColumnsRequired"
                                                                id="noOfColumnsRequired"
                                                                value={formik.values.noOfColumnsRequired}
                                                                disabled
                                                                onChange={formik.handleChange}
                                                                placeholder="Enter number of columns required"
                                                                error={
                                                                    formik.touched.noOfColumnsRequired &&
                                                                    Boolean(formik.errors.noOfColumnsRequired)
                                                                }
                                                                helperText={
                                                                    formik.touched.noOfColumnsRequired &&
                                                                    formik.errors.noOfColumnsRequired
                                                                }
                                                                sx={{ mb: 2 }}
                                                                fullWidth
                                                            />
                                                            <CustomText>Method of Execution</CustomText>
                                                            <CustomTextField
                                                                name="executionMethod"
                                                                id="executionMethod"
                                                                value={formik.values.executionMethod}
                                                                onChange={formik.handleChange}
                                                                disabled
                                                                // label="Select Season"
                                                                select
                                                                error={
                                                                    formik.touched.executionMethod &&
                                                                    Boolean(formik.errors.executionMethod)
                                                                }
                                                                helperText={
                                                                    formik.touched.executionMethod &&
                                                                    formik.errors.executionMethod
                                                                }
                                                                fullWidth
                                                                sx={{ mb: 2 }}
                                                            >
                                                                <MenuItem value={"auto"}>Auto</MenuItem>
                                                                <MenuItem value={"manual"}>Manual</MenuItem>
                                                                <MenuItem value={"override"}>Override</MenuItem>
                                                            </CustomTextField>

                                                            <CustomText>Is Zonal Approval Required ?</CustomText>
                                                            <CustomTextField
                                                                name="zonalApproval"
                                                                id="zonalApproval"
                                                                value={formik.values.overrideApprovals ? false : formik.values.zonalApproval}
                                                                onChange={formik.handleChange}
                                                                disabled
                                                                select
                                                                error={
                                                                    formik.touched.zonalApproval &&
                                                                    Boolean(formik.errors.zonalApproval)
                                                                }
                                                                helperText={
                                                                    formik.touched.zonalApproval && formik.errors.zonalApproval
                                                                }
                                                                fullWidth
                                                                sx={{ mb: 2 }}
                                                            >
                                                                <MenuItem value={true}>Yes</MenuItem>
                                                                <MenuItem value={false}>No</MenuItem>
                                                            </CustomTextField>

                                                            <CustomText>Is SHP Head Approval Required ? </CustomText>
                                                            <CustomTextField
                                                                name="shpHeadApproval"
                                                                id="shpHeadApproval"
                                                                value={formik.values.shpHeadApproval}
                                                                disabled={formik.values.executionMethod === "override"}
                                                                onChange={formik.handleChange}
                                                                // label="Select Season"
                                                                select
                                                                error={
                                                                    formik.touched.shpHeadApproval &&
                                                                    Boolean(formik.errors.shpHeadApproval)
                                                                }
                                                                helperText={
                                                                    formik.touched.shpHeadApproval &&
                                                                    formik.errors.shpHeadApproval
                                                                }
                                                                fullWidth
                                                                sx={{ mb: 2 }}
                                                            >
                                                                <MenuItem value={true}>Yes</MenuItem>
                                                                <MenuItem value={false}>No</MenuItem>
                                                            </CustomTextField>
                                                            <CustomText>Do you want to Override Approvals ?</CustomText>
                                                            <CustomTextField
                                                                name="overrideApprovals"
                                                                id="overrideApprovals"
                                                                value={formik.values.overrideApprovals}
                                                                onChange={formik.handleChange}
                                                                disabled
                                                                select
                                                                error={
                                                                    formik.touched.overrideApprovals &&
                                                                    Boolean(formik.errors.overrideApprovals)
                                                                }
                                                                helperText={
                                                                    formik.touched.overrideApprovals && formik.errors.overrideApprovals
                                                                }
                                                                fullWidth
                                                                sx={{ mb: 2 }}
                                                            >
                                                                <MenuItem value={true}>Yes</MenuItem>
                                                                <MenuItem value={false}>No</MenuItem>
                                                            </CustomTextField>

                                                            <Box sx={{ textAlign: "center" }}>
                                                                {/* <Button onClick={handleCloseTemplate}>Cancel</Button> */}



                                                                <CustomButton
                                                                    // onClick={(e) =>
                                                                    //   saveFormData(item.request_id)
                                                                    // }
                                                                    onClick={formik.handleSubmit}
                                                                    type="submit"
                                                                    disabled={submitted || loading}
                                                                    variant="contained"
                                                                    sx={{
                                                                        py: 2,
                                                                        px: 3,
                                                                        m: 2,
                                                                        background: "#58CC02",
                                                                    }}
                                                                >
                                                                    {loading ? "Submitting" : "Submit"}
                                                                </CustomButton>
                                                            </Box>
                                                        </form>
                                                    </Box>
                                                )}
                                            </DialogContent>

                                            <DialogActions sx={{ justifyContent: "center" }}>
                                                <CustomButton
                                                    // onClick={(e) => saveFormData()}
                                                    onClick={handleCloseTemplate}
                                                    variant="contained"
                                                    sx={{
                                                        py: 2,
                                                        px: 3,
                                                        m: 2,
                                                        background: "#58CC02",
                                                    }}
                                                >
                                                    Cancel
                                                </CustomButton>
                                            </DialogActions>
                                        </Dialog>
                                    </>
                                ) : null
                            )}
                    </Box>
                </Box>
            </Box>
        </div>
    );
};

export default EditRequestPage;
